export default __webpack_public_path__ + "img/jnpt1.2f9f2e5c.png";